<template>
  <q-dialog v-model="status">
    <q-card class="q-dialog-plugin card-vue">
      <q-card-actions>
        <span class="text-h6"> 提示</span>
      </q-card-actions>
      <q-separator></q-separator>
      <q-card-section class="q-pa-sm">
        {{dialogMsg}}
      </q-card-section>
      <q-card-actions align="right">
        <q-btn label="取消" size='9px' @click="onCancel"/>
        <q-btn color="primary" size='9px' label="确定" @click="onOk"/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import {isEmpty} from '@/tools/utils';
import {onMounted, ref, watch,toRef} from "vue";
export default {
  props: ["msg"],
  setup(props, context){
    let status = ref(false);
    let dialogMsg = ref('');
    let msg = toRef(props.msg);
    function setStatus (){
      status.value = !status.value;
      if(status.value){
        dialogMsg.value = isEmpty(msg.value) ? '删除后数据无法找回,请确认操作。' : msg.value;
      }
    }
    function onCancel(){
      context.emit('handleCancel');
      setStatus();
    }
    function onOk(){
      context.emit('handleOK');
      setStatus();
    }
    return {
      status,
      setStatus,
      onCancel,
      onOk,
      dialogMsg
    }
  },
};
</script>
